import TrantorStats from './trantor-stats';
import './differentiated-advantage.scss'

interface IPropsDiffBox {
  info: { logo: string, title: React.ReactNode }
}
const DiffBox = ({ info }: IPropsDiffBox) => {
  return <div className='differentiated-box-wrap'>
    <img src={info.logo} className='differentiated-box-logo' />
    <div className='differentiated-box-title'>{info.title}</div>
  </div>
}
export default () => {
  return <TrantorStats
    styleCard={{ height: '308px' }}
    items={[
      { label: <>不仅是IT软件<br/>更是覆盖从战略到执行的<br/><span className="text1">『 AI管理顾问团队 』</span></>, img: '/images/aip/diff-1.png' },
      { label: <>不是固化的系统<br/>是企业管理的<br/><span className="text2">『 AI框架 』</span></>, img: '/images/aip/diff-2.png' },
      { label: <>不止于此<br/>从“应用+AI”跃迁到<br/><span className="text2">『 AI原生应用 』</span></>, img: '/images/aip/diff-3.png' },
    ]}
    renderItem={(item) => <DiffBox key={item.img} info={{ logo: item.img, title: item.label }} />}
  />
}